// claims.form526RequiredIdentifierPresence is included in the profile when the form_526_required_identifiers_in_user_object feature flag is enabled on the back end
// We simply check for the presence of it here instead of toggling a feature flag on the front end as well
export const listMissingIdentifiers = profile => {
  const identifierDetail = profile?.claims?.form526RequiredIdentifierPresence;

  // If we do have this information, are any of the identifiers marked false, meaning we are missing that identifier on the back end?
  if (identifierDetail && typeof identifierDetail === 'object') {
    return Object.values(identifierDetail).some(
      idPresence => idPresence === false,
    );
  }

  return false;
};
